/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { configureStore } from "@reduxjs/toolkit";
import flowReducer from "./slices/flowSlice";
import bookingReducer from "./slices/bookingSlice";
import cartReducer from "./slices/cartSlice";
import directOrderReducer from "./slices/directOrderSlice";
import productsReducer from "./slices/productsSlice";
import { flowMiddleware } from "./middleware/flowMiddleware";
import { membershipCallbackMiddleware } from "./middleware/membershipCallbackMiddleware";

export const store = configureStore({
  reducer: {
    flow: flowReducer,
    booking: bookingReducer,
    cart: cartReducer,
    directOrder: directOrderReducer,
    products: productsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(flowMiddleware, membershipCallbackMiddleware),
});
